import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lmsInitials' })
export class InitialsPipe implements PipeTransform {
  constructor() {}

  transform(completeName: string): string {
    if (completeName) {
      const [name, surname = ' '] = completeName.split(' ');
      const [nameInitial] = name.split('');
      const [surnameInitial] = surname.split('');
      return (nameInitial + surnameInitial).trim().toUpperCase();
    }
    return '';
  }
}
